import RequestProducts from './RequestProductsContainer.vue';

export { RequestProducts };



// WEBPACK FOOTER //
// ./src/modules/home/requestProducts/index.js